// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"CI-z","smallCardRow":"DI-z","largeCardRow":"EI-z","productSearchRow":"FI-z","curatedRow":"GI-z"};